export default "__VITE_ASSET__C5s4DTum__"